<template>
  <!-- 报名成功 -->
  <div class="title">
    <div class="sign_s">
      <div class="sign_one">
        <span class="iconfont">&#xe62c;</span>
        <p>会员未获取资源权限!</p>
      </div>
      <van-row class="sign_two">
        <router-link to="/">
          <van-col span="24" style="color:#fd882b">去首页</van-col>
        </router-link>
      </van-row>
    </div>
    <footerFixed/>
  </div>
</template>

<script>
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        footerNav: false,
      };
    },
    created: function() {
      var _this = this;
    },
    methods: {
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
    }
  };
</script>

<style lang="less" scoped>
  .title {
    width: 100%;
    min-height: 100vh;
    background: #f7f7f7;
    font-size: 28px;

    .sign_s {
      font-size: 30px;
      background-color: white;
      padding: 100px 30px;
      letter-spacing: 3px;

      .sign_one {
        text-align: center;
        font-weight: 600;

        span {
          display: inline-block;
          font-size: 100px;
          color: #ff0000;
        }

        p {
          margin: 50px 0px;
        }

        .tishi {
          min-height: 20px;
          margin-bottom: 30px;
          padding: 5px 20px;
        }
      }

      .sign_two {
        width: 523px;
        height: 88px;
        line-height: 88px;
        padding: 0 20px;
        text-align: center;
        border: 1px solid #fd882b;
        color: #fd882b;
        margin: auto;
        border-radius: 100px;
        text-align: center;

        .order,
        .fapiao {
          position: relative;
        }

        .order::after {
          content: "";
          height: 60px;
          width: 2px;
          position: absolute;
          right: 0;
          top: 14px;
          background: linear-gradient(to top, #f2f2f2, #fd882b, #eaeaea);
        }

        .fapiao::after {
          content: "";
          height: 60px;
          width: 2px;
          position: absolute;
          right: 0;
          top: 14px;
          background: linear-gradient(to top, #f2f2f2, #fd882b, #eaeaea);
        }
      }
    }
  }
</style>
